export class DropdownOptionsModel {
  value: string = '';
  label: string = '';
  isDisabled: boolean = false;
}
